<template>
  <div>
    <div
      class="modal fade"
      id="modal-email-template-detail"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("mail_form.title_add_new") }}
            </h4>
          </div>
          <div class="modal-body">
            <div>
              <form>
                <div class="box-body">
                  <div>
                    <p>{{ $t("mail_form.title_intro") }}</p>
                  </div>
                  <div>
                    <!-- classify -->
                    <div class="contain_info">
                      <div>{{ $t("mail_form.classify") }}</div>
                      <div style="width:75%">
                        <select
                          @change="handleOnClassify(keyClassify)"
                          class="form-control"
                          v-model="keyClassify"
                        >
                          <option
                            v-for="item in classify"
                            v-bind:value="item.id"
                            :key="item.id"
                            >{{ $t(item.text) }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <!-- choose field -->
                    <div class="contain_info">
                      <div>{{ $t("mail_form.choose_field") }}</div>
                      <div style="width:75%">
                        <select
                          @change="handleOnPickField(keyPField)"
                          class="form-control"
                          v-model="keyPField"
                        >
                          <option
                            v-for="item in pickfields"
                            v-bind:value="item"
                            :key="item.id"
                            >{{ item.text }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <!-- copy field -->
                    <div style="display: flex; justify-content: space-between">
                      <div>{{ $t("mail_form.copy_field") }}</div>
                      <div style="width: 75%" class="contain_info">
                        <span class="text-center">{{ form.copyfield }}</span>
                        <input
                          type="hidden"
                          id="inputcopy"
                          v-model="form.copyfield"
                        />
                      </div>
                    </div>
                    <div style="margin-bottom: 5%">
                      <h4>{{ $t("mail_form.email_form_info") }}</h4>
                    </div>
                    <div class="contain_info">
                      <div>{{ $t("mail_form.form_name") }}</div>
                      <input
                        type="text"
                        v-model="form.formname"
                        style="width: 75%"
                      />
                    </div>
                    <div class="contain_info">
                      <div>{{ $t("mail_form.description") }}</div>
                      <input
                        type="text"
                        v-model="form.description"
                        style="width: 75%"
                      />
                    </div>
                    <div class="contain_info">
                      <div>{{ $t("mail_form.subject") }}</div>
                      <input
                        type="text"
                        v-model="form.subject"
                        style="width: 75%"
                      />
                    </div>
                    <!-- content  -->
                    <div>
                      <label for="subject">{{ $t("mail_form.content") }}</label>
                      <div>
                        <trumbowyg
                          v-model="form.content"
                          :config="config"
                          name="content"
                        ></trumbowyg>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer" style="text-align: center">
              <button
                style="background-color: #f29911;border-color: #f29911;color:#fff"
                type="button"
                class="btn btn-default pull-left"
                @click="onCloseModal"
              >
                {{ $t("common.back") }}
              </button>
              <button
                class="btn btn-success pull-right"
                style="margin-left: 6px;"
                @click="onSaveTemplate"
              >
                <i class="glyphicon glyphicon-floppy-saved"></i>
                {{ $t("common.save") }}
              </button>
            </div>
            <!--  -->
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
    <div
      class="modal fade"
      data-backdrop="static"
      id="modal-view-template-default"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t("common.add_user_to_project") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label for="">{{
                    $t("templateNotification.templateTitle")
                  }}</label>
                  <p>
                    {{
                      templateNotificationDefaultSelect &&
                        templateNotificationDefaultSelect.title
                    }}
                  </p>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label for="">{{
                    $t("templateNotification.templateContent")
                  }}</label>
                  <p>
                    {{
                      templateNotificationDefaultSelect &&
                        templateNotificationDefaultSelect.content
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              :class="'btn btn-primary pull-right'"
              @click="onConfirmUseTemplate"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-warning pull-left"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    Trumbowyg
  },
  data: () => ({
    templateFieldList: [],
    templateFieldSelect: null,
    templateNotificationDefault: [],
    templateNotificationDefaultSelect: null,
    templateData: {
      id: 0,
      name: null,
      templateTitle: null,
      templateContent: null
    },
    categoryId: null,
    //
    config: {
      // Get options from
      // https://alex-d.github.io/Trumbowyg/documentation
    },
    keyPField: "",
    keyClassify: "",
    form: {
      id: null,
      classify: null,
      pickfield: null,
      active: true,
      formname: null,
      description: null,
      subject: null,
      content: null,
      copyfield: null
    },
    pickfields: [],
    fields: [],
    classify: []
  }),
  watch: {
    GET_TEMPLATE_EMAIL_OB_DATA: function() {
      this.classify = [];
      this.fields = [];
      this.GET_TEMPLATE_EMAIL_OB_DATA.forEach(item => {
        let pickfield = item.fields;
        let data = {
          id: item.id,
          text: item.name
        };

        this.classify.push(data);
        this.fields.push(pickfield);
      });
      if (this.classify.length ===1) {
        this.keyClassify = this.classify[0].id
        this.handleOnClassify(this.keyClassify)
      }
    },
    GET_TEMPLATE_DETAIL_DATA: function() {
      let data = this.GET_TEMPLATE_DETAIL_DATA;
      this.form.active = data.active;
      this.form.formname = data.name;
      this.form.description = data.description;
      this.form.subject = data.subject;
      this.form.content = data.content;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_TEMPLATE_EMAIL_OB_DATA",
      "GET_TEMPLATE_DETAIL_DATA"
    ])
  },
  methods: {
    onShowModal: function() {
      $("#modal-email-template-detail").modal("show");
    },
    onCloseModal: function() {
      $("#modal-email-template-detail").modal("hide");
    },
    setDefaultValue: function() {
      this.form.id = null;
      this.form.classify = null;
      this.form.pickfield = null;
      this.form.active = true;
      this.form.formname = null;
      this.form.description = null;
      this.form.subject = null;
      this.form.content = '';
      this.form.copyfield = null;
    },
    onAddNewTemplate: function(categoryId) {
      this.categoryId = categoryId;
      this.setDefaultValue();
      this.getEmailTemplateObject();
      this.onShowModal();
    },
    onDetailTemplate: function(categoryId, id) {
      this.categoryId = categoryId;
      this.onShowModal();
      this.setDefaultValue();
      this.getEmailTemplateObject();
      this.form.id = id
      this.GET_TEMPLATE_DETAIL({ id: id });
    },
    onCallbackTemplate: function() {
      let categoryId = this.$route.params.categoryId;
      this.$router.push({
        name: "TemplateNotification",
        params: {
          categoryId: categoryId
        }
      });
    },
    getFieldNotificationByCategory: function() {
      let categoryId = this.$route.params.categoryId;
      let filter = {
        params: {
          categoryId: categoryId
        }
      };
      this.GET_FIELD_NOTIFICATION_BY_CATEGORY(filter).then(
        function(res) {
          this.templateFieldList = [];
          let data = res.data;
          data.forEach(v => {
            let item = {
              id: v.id,
              name: v.name,
              value: v.value
            };
            this.templateFieldList.push(item);
          });
        }.bind(this)
      );
    },
    onInsertTemplateField: function(data) {
      if (data) {
        var currentVal = $("textarea").val();
        $("textarea.AddMessage").val(currentVal + data.value);
      }
    },
    getTemplateNotificationDefault: function() {
      let categoryId = this.$route.params.categoryId;
      let filter = {
        params: {
          categoryId: categoryId
        }
      };
      this.GET_TEMPLATE_NOTIFICATION_DEFAULT(filter).then(
        function(res) {
          this.templateNotificationDefault = [];
          let data = res.data;
          data.forEach(v => {
            let item = {
              id: v.id,
              name: v.name,
              title: v.title,
              content: v.content
            };
            this.templateNotificationDefault.push(item);
          });
        }.bind(this)
      );
    },
    onViewTemplateDefault: function() {
      $("#modal-view-template-default").modal("show");
    },
    onConfirmUseTemplate: function() {
      $("#modal-view-template-default").modal("hide");
      if (this.templateNotificationDefaultSelect) {
        this.templateData.templateTitle = this.templateNotificationDefaultSelect.title;
        this.templateData.templateContent = this.templateNotificationDefaultSelect.content;
      }
    },
    validateTemplate: function() {
      let validateResults = "OK";
      if (utils.isEmptyString(this.form.formname)) {
        validateResults = this.$t("mail_form.form_name");
      } else if (utils.isEmptyString(this.form.subject)) {
        validateResults = this.$t("mail_form.subject");
      } else if (utils.isEmptyString(this.form.content)) {
        validateResults = this.$t("mail_form.content");
      }
      return validateResults;
    },
    onSaveTemplate: function() {
      let result = this.validateTemplate();
      if (result === "OK") {
        let data = {
          id: this.form.id,
          classify: this.keyClassify,
          pickfield: this.keyPField,
          active: this.form.active,
          name: this.form.formname,
          description: this.form.description,
          subject: this.form.subject,
          content: this.form.content,
          categoryId: this.categoryId
        };
        this.isLoading = true;
        if (this.form.id == null) {
          this.ADD_TEMPLATE_EMAIL(data)
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.onCloseModal();
                this.$emit("callbackEmailTemplateList", true);
                this.isLoading = false;
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
                this.isLoading = false;
              }.bind(this)
            );
        } else {
          this.UPDATE_TEMPLATE_EMAIL(data)
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.onCloseModal();
                this.$emit("callbackEmailTemplateList", true);
                this.isLoading = false;
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
                this.isLoading = false;
              }.bind(this)
            );
        }
      } else {
        this.showError(result);
      }
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    getEmailTemplateObject: function() {
      let filter = {
        params: {
          categoryId: this.categoryId
        }
      };
      this.GET_TEMPLATE_EMAIL_OBJECT(filter);
    },
    handleOnClassify(id) {
      this.pickfields = [];
      this.fields[id - 1].forEach((el, idx) => {
        let data = {
          id: idx,
          text: el.api
        };
        this.pickfields.push(data);
      });
    },
    copyFunction(value) {
      let copyText = document.getElementById("inputcopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      document.execCommand("copy");
      copyText.setAttribute("type", "hidden");
      alert("Copied the text: " + copyText.value);
    },
    handleOnPickField(item) {
      let text = item.text;
      this.form.copyfield = `{{ ${text} }}`;
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "GET_FIELD_NOTIFICATION_BY_CATEGORY",
      "GET_TEMPLATE_NOTIFICATION_DEFAULT",
      "ADD_TEMPLATE_EMAIL",
      "UPDATE_TEMPLATE_EMAIL",
      "GET_TEMPLATE_NOTIFICATION_DETAIL",
      //
      "GET_TEMPLATE_EMAIL_OBJECT",
      "GET_TEMPLATE_DETAIL"
    ])
  },
  mounted() {},
  created() {
    this.getFieldNotificationByCategory();
    this.getTemplateNotificationDefault();
    let id = this.$route.params.id;
    if (id !== undefined && id !== 0) {
      this.GET_TEMPLATE_NOTIFICATION_DETAIL({ id: id }).then(
        function(res) {
          this.templateData.id = res.id;
          this.templateData.name = res.name;
          this.templateData.templateTitle = res.title;
          this.templateData.templateContent = res.content;
        }.bind(this)
      );
    }
  }
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.contain_info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4%;
}
</style>



// WEBPACK FOOTER //
// src/views/Mailbox/EmailTemplateDetail.vue